import { pathGenerator, PathGenerator } from "./_/pathGenerator"

export type { PathGenerator } from "./_/pathGenerator"
export { RoutePath, RoutePathDefault } from "./_/RoutePath"

export function usePathGenerator(): PathGenerator {
  return pathGenerator
}
